var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ s_view_scene: _vm.ageGateConfirmation },attrs:{"id":"app"}},[_c('Symbols'),_c('TopBar'),_c('BackgroundGlobes'),_c('Scene',{attrs:{"scale":_vm.scale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }